var map = {
	"./afaanoromoo": 67976,
	"./afaanoromoo.ts": 67976,
	"./afrique": 61090,
	"./afrique.ts": 61090,
	"./amharic": 54126,
	"./amharic.ts": 54126,
	"./arabic": 95422,
	"./arabic.ts": 95422,
	"./archive": 94852,
	"./archive.ts": 94852,
	"./azeri": 62588,
	"./azeri.ts": 62588,
	"./bengali": 40565,
	"./bengali.ts": 40565,
	"./burmese": 41698,
	"./burmese.ts": 41698,
	"./cymrufyw": 48137,
	"./cymrufyw.ts": 48137,
	"./gahuza": 46103,
	"./gahuza.ts": 46103,
	"./gujarati": 43521,
	"./gujarati.ts": 43521,
	"./hausa": 72483,
	"./hausa.ts": 72483,
	"./hindi": 8220,
	"./hindi.ts": 8220,
	"./igbo": 6222,
	"./igbo.ts": 6222,
	"./indonesia": 92191,
	"./indonesia.ts": 92191,
	"./japanese": 31448,
	"./japanese.ts": 31448,
	"./korean": 12071,
	"./korean.ts": 12071,
	"./kyrgyz": 7897,
	"./kyrgyz.ts": 7897,
	"./marathi": 81548,
	"./marathi.ts": 81548,
	"./mundo": 25368,
	"./mundo.ts": 25368,
	"./naidheachdan": 53460,
	"./naidheachdan.ts": 53460,
	"./nepali": 32306,
	"./nepali.ts": 32306,
	"./news": 83689,
	"./news.ts": 83689,
	"./newsround": 34974,
	"./newsround.ts": 34974,
	"./pashto": 70240,
	"./pashto.ts": 70240,
	"./persian": 49864,
	"./persian.ts": 49864,
	"./pidgin": 11005,
	"./pidgin.ts": 11005,
	"./portuguese": 28036,
	"./portuguese.ts": 28036,
	"./punjabi": 71411,
	"./punjabi.ts": 71411,
	"./russian": 42184,
	"./russian.ts": 42184,
	"./scotland": 12698,
	"./scotland.ts": 12698,
	"./serbian": 57105,
	"./serbian.ts": 57105,
	"./sinhala": 38241,
	"./sinhala.ts": 38241,
	"./somali": 27833,
	"./somali.ts": 27833,
	"./sport": 79426,
	"./sport.ts": 79426,
	"./swahili": 91569,
	"./swahili.ts": 91569,
	"./tamil": 49976,
	"./tamil.ts": 49976,
	"./telugu": 94777,
	"./telugu.ts": 94777,
	"./thai": 55696,
	"./thai.ts": 55696,
	"./tigrinya": 52161,
	"./tigrinya.ts": 52161,
	"./turkce": 72297,
	"./turkce.ts": 72297,
	"./ukchina": 76270,
	"./ukchina.ts": 76270,
	"./ukrainian": 83788,
	"./ukrainian.ts": 83788,
	"./urdu": 19632,
	"./urdu.ts": 19632,
	"./uzbek": 91151,
	"./uzbek.ts": 91151,
	"./vietnamese": 41580,
	"./vietnamese.ts": 41580,
	"./yoruba": 54795,
	"./yoruba.ts": 54795,
	"./zhongwen": 40069,
	"./zhongwen.ts": 40069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 22884;
module.exports = webpackContext;